module.exports = __webpack_public_path__ + "components/flag/static/square/lk-e08965c6219aff63881d2c84c49d8967.svg";